import { SubscriptionRouter } from '@domains/subscription/router/router'
import { AuthPersonPage } from 'pages/AuthPerson/AuthPersonPage'
import { IntegrationErrorMain } from 'pages/IntegrationError/IntegrationErrorMain'
import type React from 'react'
import { Route } from 'react-router-dom'
import AccountingPage from '../components/AccountingPage'
import CustomerDetailsPage from '../components/CustomerDetailsPage'
import ExternalPage from '../components/ExternalPage'
import InboxPage from '../components/InboxPage'
import SearchResultPage from '../components/SearchResultsPage'
import { FraudCasesAdapter } from '../pages/FraudCases'
import RollingCreditAdapter from '../pages/RollingCredit'
import routes from './constants'
import type { Permissions } from 'appPermissions'
import { SpendControlPage } from 'SpendControl'

export interface RouteComponentProps {
  heading: React.ReactNode
}

type CustomRouter = {
  route: (props: RouteComponentProps) => React.ReactNode
  permissions: Permissions[]
}

type ProtectedRoute = {
  path: string
  component: () => React.ReactElement
  fullScreenWidth?: boolean
  permissions: Permissions[]
}

export const isCustomRouter = (route: unknown): route is CustomRouter => {
  return (route as CustomRouter).route !== undefined
}

export const protectedRoutes: (ProtectedRoute | CustomRouter)[] = [
  {
    path: `/spend-controls`,
    component: () => <SpendControlPage />,
    permissions: ['customers.view'],
  },
  {
    permissions: ['customers.view'],
    route: ({ heading }) => (
      <Route path="">
        <Route path={`${routes.CUSTOMERS_PATH}/:customerId`} element={<CustomerDetailsPage heading={heading} />}>
          <Route path=":tab1" element={<CustomerDetailsPage heading={heading} />}>
            <Route path=":tab2" element={<CustomerDetailsPage heading={heading} />} />
          </Route>
        </Route>
      </Route>
    ),
  },
  {
    path: routes.ROLLING_CREDIT,
    component: () => <RollingCreditAdapter paddingTop="40px" />,
    permissions: ['rolling-credit'],
  },
  {
    path: routes.SPEND_CONTROLS,
    component: () => <SpendControlPage />,
    permissions: ['rolling-credit'],
  },
  {
    path: `${routes.INBOX_PATH}`,
    component: () => <InboxPage />,
    permissions: ['inbox.view'],
  },
  {
    path: '/search',
    component: () => <SearchResultPage />,
    permissions: ['search'],
  },
  {
    path: `${routes.ACCOUNTING_PATH}`,
    component: () => <AccountingPage />,
    permissions: ['accounting'],
  },
  {
    path: '/external',
    component: () => <ExternalPage />,
    permissions: ['external'],
  },
  {
    path: '/integration-error',
    component: () => <IntegrationErrorMain />,
    permissions: ['customers.view'],
  },
  {
    path: routes.SUBSCRIPTION_PATH,
    route: SubscriptionRouter,
    permissions: ['subscription'],
  },
  {
    path: routes.FRAUD_CASES_PATH,
    component: () => <FraudCasesAdapter />,
    permissions: ['fraud-cases'],
  },
  {
    path: routes.AUTH_PERSON_PATH,
    component: () => <AuthPersonPage />,
    permissions: ['*'],
  },
]
